import { Component } from '@angular/core';
import { SideMenuComponent } from "../side-menu/side-menu.component";
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-company-profile',
  standalone: true,
  imports: [SideMenuComponent, TranslateModule],
  templateUrl: './company-profile.component.html',
  styleUrl: './company-profile.component.css'
})
export class CompanyProfileComponent {

  baseApiUrl = environment.baseApiUrl;
  
}
